import { COLOR_PALETTE } from 'constants/ui';

export const overlayStyles = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1400,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
};

export const containerStyles = {
  width: 400,
  maxWidth: '90vw',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '12px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
  overflow: 'hidden',
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px 20px',
  backgroundColor: COLOR_PALETTE.BLUE[1],
  borderBottom: `1px solid ${COLOR_PALETTE.BLUE[2]}`,
};

export const liveTransferHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px 20px',
  backgroundColor: COLOR_PALETTE.RED[1],
  borderBottom: `1px solid ${COLOR_PALETTE.RED[2]}`,
};

export const headerTitleStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const bodyStyles = {
  padding: '20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const fieldRowStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const fieldLabelStyles = {
  color: ({ palette }) => palette.text.placeholder,
};

export const fieldValueStyles = {
  fontWeight: 500,
};

export const actionsStyles = {
  display: 'flex',
  gap: '12px',
  padding: '0 20px 20px',
};

export const acceptButtonStyles = {
  flex: 1,
  textTransform: 'none',
  borderRadius: '8px',
  fontWeight: 600,
};

export const rejectButtonStyles = {
  flex: 1,
  textTransform: 'none',
  borderRadius: '8px',
  fontWeight: 600,
};

export const timerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  color: ({ palette }) => palette.text.placeholder,
};
